import React from 'react';
import { Line } from 'react-chartjs-2';
import { IoArrowDownSharp, IoArrowUpSharp } from 'react-icons/io5';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';

interface RegisteredTimeDashboardUtilitiesProps {
    kpiData: any;
}

const RegisteredTimeDashboardUtilities: React.FC<RegisteredTimeDashboardUtilitiesProps> = ({ kpiData }) => {
    const renderKpiBox = (title: string, currentValue: number | null, pastValue: number | null, comparisonData: any) => {
        return (
            <Col xl={12} lg={12} md={12} sm={12} xs={12} className="mb-3">
                <div
                    style={{
                        backgroundColor: "#fbc02d",
                        color: "#785c15",
                        padding: "1rem",
                        borderRadius: "8px",
                        textAlign: "center",
                        height: "100%",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gridTemplateRows: "auto auto auto",
                        gap: "0.3rem",
                        // maxHeight: "230px"
                    }}
                >
                    {/* Título e Valor (1) */}
                    <div style={{ fontSize: "0.9rem", textAlign: "left" }}>
                        <FormattedMessage id="Screens.Dashboard.Registered.Hours.Current.Week" />
                        {" "}
                        <strong>{comparisonData?.currentWeekRegisteredHours ?? "N/A"}</strong>
                    </div>

                    {/* Comparação com Semana Anterior (2) */}
                    <div style={{ fontSize: "0.9rem", textAlign: "left" }}>
                        <FormattedMessage id="Screens.Dashboard.Registered.Hours.Past.Week" />
                        {" "}
                        <strong>{comparisonData?.pastWeekRegisteredHours ?? "N/A"}</strong>
                    </div>

                    {/* Setas e Percentagem (3) */}
                    <div style={{ gridColumn: "1 / 3", textAlign: "left" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
                            {comparisonData?.currentWeekRegisteredHours &&
                                comparisonData?.pastWeekRegisteredHours &&
                                comparisonData.currentWeekRegisteredHours >
                                comparisonData.pastWeekRegisteredHours ? (
                                <IoArrowUpSharp size={20} />
                            ) : (
                                <IoArrowDownSharp size={20} />
                            )}
                            <span style={{ marginLeft: "0.5rem" }}>
                                {comparisonData?.currentWeekRegisteredHours &&
                                    comparisonData?.pastWeekRegisteredHours
                                    ? (
                                        ((comparisonData.currentWeekRegisteredHours -
                                            comparisonData.pastWeekRegisteredHours) /
                                            comparisonData.pastWeekRegisteredHours) *
                                        100
                                    ).toFixed(2) + "%"
                                    : "0%"}
                            </span>
                        </div>
                    </div>

                    {/* Gráfico de Linha (4) */}
                    <div style={{ gridColumn: "1 / 3", height: "100px" }}>
                        <Line
                            data={{
                                labels: ['', '', '', '', '', ''],
                                datasets: [
                                    {
                                        label: '',
                                        data: [
                                            comparisonData?.registeredHoursSixMonthsAgo ?? 0,
                                            comparisonData?.registeredHoursFiveMonthsAgo ?? 0,
                                            comparisonData?.registeredHoursFourMonthsAgo ?? 0,
                                            comparisonData?.registeredHoursThreeMonthsAgo ?? 0,
                                            comparisonData?.registeredHoursTwoMonthsAgo ?? 0,
                                            comparisonData?.registeredHoursOneMonthAgo ?? 0,
                                        ],
                                        fill: false,
                                        borderColor: '#785c15',
                                        tension: 0.1,
                                    },
                                ],
                            }}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    legend: { display: false },
                                    title: { display: false },
                                },
                                scales: {
                                    x: {
                                        ticks: { color: '#785c15' },
                                        grid: { display: false },
                                    },
                                    y: {
                                        ticks: { color: '#785c15' },
                                        grid: { display: false },
                                    },
                                },
                            }}
                        />
                    </div>

                    {/* Média e Variação (5) */}
                    <div style={{ gridColumn: "1 / 3", textAlign: "left" }}>
                        Média 6 meses: {([
                            comparisonData?.registeredHoursSixMonthsAgo ?? 0,
                            comparisonData?.registeredHoursFiveMonthsAgo ?? 0,
                            comparisonData?.registeredHoursFourMonthsAgo ?? 0,
                            comparisonData?.registeredHoursThreeMonthsAgo ?? 0,
                            comparisonData?.registeredHoursTwoMonthsAgo ?? 0,
                            comparisonData?.registeredHoursOneMonthAgo ?? 0,
                        ]
                            .reduce((acc, curr) => acc + curr, 0) / 6
                        ).toFixed(1)}
                        <strong>
                            (
                            {(
                                comparisonData?.registeredHoursSixMonthsAgo &&
                                    comparisonData?.registeredHoursSixMonthsAgo !== 0
                                    ? (
                                        ((comparisonData.registeredHoursOneMonthAgo ?? 0) -
                                            (comparisonData.registeredHoursSixMonthsAgo ?? 0)) /
                                        comparisonData.registeredHoursSixMonthsAgo
                                    ) * 100
                                    : 0
                            ).toFixed(1)}%
                            )
                        </strong>
                    </div>
                </div>
            </Col>
        );
    };

    return (
        <div>
            <Row style={{ flexWrap: "wrap" }}>
                {kpiData && kpiData.registeredHoursComparison && renderKpiBox(
                    "Horas Registadas da Semana",
                    kpiData.registeredHoursComparison.currentWeekRegisteredHours,
                    kpiData.registeredHoursComparison.pastWeekRegisteredHours,
                    kpiData.registeredHoursComparison
                )}
            </Row>
        </div>
    );
};

export default RegisteredTimeDashboardUtilities;